var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNoFavouritesYet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "78px",
    viewBox: "0 0 80 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icNoFavouritesYet") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M226.170868,187.2928 C227.743668,185.76 228.298868,183.5104 227.620468,181.4192 C226.940468,179.328 225.169268,177.8352 222.993268,177.5184 L203.646068,174.7072 C202.822068,174.5872 202.110068,174.0704 201.742068,173.3232 L193.092468,155.7936 C192.121268,153.824 190.150068,152.6 187.953268,152.6 C185.758068,152.6 183.786868,153.824 182.815668,155.7936 L174.164468,173.3248 C173.796468,174.072 173.082868,174.5888 172.258868,174.7088 L152.911668,177.52 C150.737268,177.8352 148.964468,179.3296 148.284468,181.4208 C147.606068,183.512 148.161268,185.7616 149.734068,187.2944 L163.732468,200.9392 C164.329268,201.5216 164.602868,202.36 164.462068,203.1792 L161.159668,222.4464 C160.866868,224.1424 161.311668,225.792 162.409268,227.0928 C164.114868,229.12 167.092468,229.7376 169.473268,228.4864 L186.775668,219.3888 C187.498868,219.0096 188.409268,219.0128 189.130868,219.3888 L206.434868,228.4864 C207.276468,228.9296 208.174068,229.1536 209.100468,229.1536 C210.791668,229.1536 212.394868,228.4016 213.497268,227.0928 C214.596468,225.792 215.039668,224.1392 214.746868,222.4464 L211.442868,203.1792 C211.302068,202.3584 211.575668,201.5216 212.172468,200.9392 L226.170868,187.2928 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Views-Non-display-Copy-2",
    transform: "translate(-148.000000, -152.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icNoFavouritesYet",
    fillOpacity: 0.6,
    fill: "#666666",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoFavouritesYet);
export default __webpack_public_path__ + "static/media/icNoFavouritesYet.b68cadfe00abadf7d20c809352060092.svg";
export { ForwardRef as ReactComponent };